const enumList = undefined
const ssiBase = undefined
const courseList = undefined
export default
{
  enumList,
  ssiBase,
  courseList
}
